import { AxiosResponse } from 'axios'
import { ApiRepository } from 'repository/api-repository'
import { ApiResponse } from 'service/protocols/api/api-client'
import {
  IApiRepository,
  RepositoryRequest
} from 'service/protocols/api/api-repository'
import { GetStorage } from 'service/protocols/cache/get-storage'

export class PrepareApiRequestSurgicalPresignedUrlDecorator
  implements IApiRepository
{
  constructor(
    private readonly getStorage: GetStorage,
    private readonly apiRepository: ApiRepository
  ) {}

  private injectAuth(data: RepositoryRequest): void {
    const account = this.getStorage.get('account')
    if (account?.accessToken) {
      Object.assign(data, {
        headers: Object.assign(data.headers || {}, {
          authorization: 'Bearer ' + account.accessToken
        })
      })
    }
  }

  private resolveUrl(path: string): string {
    return process.env.NODE_ENV === 'production'
      ? `/api-surgical-presigned${path}`
      : `${process.env.REACT_APP_API_AWS_DOCUMENT + path}`
  }

  async post(data: RepositoryRequest): Promise<ApiResponse> {
    this.injectAuth(data)
    data.url = this.resolveUrl(data.url)
    return await this.apiRepository.post(data)
  }

  async get(
    data: RepositoryRequest,
    is_file?: boolean
  ): Promise<ApiResponse | AxiosResponse> {
    this.injectAuth(data)
    data.url = this.resolveUrl(data.url)
    return await this.apiRepository.get(data, is_file)
  }

  async put(data: RepositoryRequest): Promise<ApiResponse> {
    this.injectAuth(data)
    data.url = this.resolveUrl(data.url)
    return await this.apiRepository.put(data)
  }
}
